import Vue from "vue";

import NewsSlider from "./news-slider/news-slider";
import FeaturedSlider from "./featured-slider/featured-slider";
import Gallery from "./gallery/gallery";
import TvStatus from "./tv-status/tv-status";
import TvPartners from "./tv-partners/tv-partners";
import ForceRefresh from "./force-refresh/force-refresh";
import VueShave from "vue-shave";
import vueSmoothScroll from "vue2-smooth-scroll";
import VueYoutube from "vue-youtube";
import EgSearch from "./EgSearch/EgSearch.vue";
import VideoPlayer from "./vue/VideoPlayer.vue";
import SubmitButton from "./vue/objects/SubmitButton.vue";
import EventBus from "./eventBus";
import StickyContact from "./CtaContainer/StickyContact/StickyContact.vue";
import CallMe from "./CtaContainer/CallMe/CallMe.vue";
import CtaContainer from "./CtaContainer/CtaContainer.vue";
import Newsletter from "./vue/Newsletter.vue";
import Accordion from "./vue/blocks/Accordion.vue";

Vue.use(vueSmoothScroll);
Vue.use(VueYoutube);
Vue.use(VueShave);

export default new Vue({
  el: "#root",
  components: {
    NewsSlider,
    FeaturedSlider,
    Gallery,
    EgSearch,
    VideoPlayer,
    SubmitButton,
    TvStatus,
    TvPartners,
    ForceRefresh,
    StickyContact,
    CallMe,
    CtaContainer,

    Newsletter,
    Accordion,
  },
  data() {
    return {
      showSearch: false,
      megahover: false,
    };
  },
  methods: {
    toggleSearch() {
      this.showSearch = !this.showSearch;
    },
    toggleMobileMenu(ref) {
      this.$refs[ref].classList.toggle("open");
    },
  },
  mounted() {
    EventBus.$on("close-search", () => {
      this.toggleSearch();
    });
  },
});



// WEBPACK FOOTER //
// ./assets/_js/components/root.js